module.exports = coreApis.componentApis.feeds.notify;